import React from "react";
import ListAllTemplates from "../../threads/children/ListAllTemplates";

export default function ListTemplates() {
  return <ListAllTemplates />;
}
